import { Center, Table, Tbody, Td, Thead, Tr, Th } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { Notifications } from '@finley-technologies/finley-types';

import {
  EmailSubscriptionGQLType,
  EmailTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { Badge } from 'packages/common-frontend/components/Badge';

const isEmailTypeEnabledForUser = (
  emailSubscriptions: EmailSubscriptionGQLType[],
  emailType: EmailTypeGQLType,
) =>
  _.some(
    emailSubscriptions,
    (emailSubscription) => emailSubscription.emailType === emailType,
  );

// TODO[JEN]: Refactor to render with config based on available email types (Kevin suggestion)
const EmailSubscriptionSettings = ({
  creditFacilitySlugs,
  emailSubscriptions,
}: {
  creditFacilitySlugs: string[];
  emailSubscriptions: EmailSubscriptionGQLType[];
}) => {
  return (
    <Table maxWidth="500px">
      <Thead>
        <Tr>
          <Th>Email Type</Th>
          <Th textAlign="center">Subscription Status</Th>
        </Tr>
      </Thead>
      <Tbody>
        {creditFacilitySlugs.length > 0 && (
          <Tr>
            <Td>Digest Email</Td>
            <Td textAlign="center">
              <Center>
                {isEmailTypeEnabledForUser(
                  emailSubscriptions,
                  Notifications.EmailType.digestEmail,
                ) ? (
                  <Badge
                    colorScheme="green"
                    aria-label="digest email enabled"
                    width="fit-content"
                  >
                    Enabled
                  </Badge>
                ) : (
                  <Badge
                    colorScheme="red"
                    aria-label="digest email disabled"
                    width="fit-content"
                  >
                    Disabled
                  </Badge>
                )}
              </Center>
            </Td>
          </Tr>
        )}
        {creditFacilitySlugs.length > 0 && (
          <Tr>
            <Td>Funding Request Emails</Td>
            <Td textAlign="center">
              <Center>
                {isEmailTypeEnabledForUser(
                  emailSubscriptions,
                  Notifications.EmailType.fundingRequestEmail,
                ) ? (
                  <Badge
                    colorScheme="green"
                    aria-label="funding request email enabled"
                    width="fit-content"
                  >
                    Enabled
                  </Badge>
                ) : (
                  <Badge
                    colorScheme="red"
                    aria-label="funding request email disabled"
                    width="fit-content"
                  >
                    Disabled
                  </Badge>
                )}
              </Center>
            </Td>
          </Tr>
        )}
        <Tr>
          <Td>Deliverables Email</Td>
          <Td textAlign="center">
            <Center>
              {isEmailTypeEnabledForUser(
                emailSubscriptions,
                Notifications.EmailType.upcomingDeliverableEmail,
              ) ? (
                <Badge
                  colorScheme="green"
                  aria-label="deliverable email enabled"
                  width="fit-content"
                >
                  Enabled
                </Badge>
              ) : (
                <Badge
                  colorScheme="red"
                  aria-label="deliverable email disabled"
                  width="fit-content"
                >
                  Disabled
                </Badge>
              )}
            </Center>
          </Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default EmailSubscriptionSettings;
